import type { Space } from '@cocoonspace/sdk-js/types/space'
import { Button } from '@cocoonspace/ui/components/button'
import { Card } from '@cocoonspace/ui/components/card'
import { Trans } from '@lingui/react/macro'
import { motion } from 'motion/react'

import { useBookingActiveStep } from '~/domains/spaces/components/space-details/space-details-sidebar/use-booking-active-step.hook'
import { SpaceVisitDialog } from '~/domains/spaces/components/space-details/space-visit/space-visit-dialog'

export const VisitInfobox = ({ space }: { space: Space }) => {
	return (
		<SpaceVisitDialog space={space}>
			<Trans>
				👀 Vous souhaitez visiter ce Cocoon avant de réserver ?{' '}
				<Button
					size='sm'
					variant='link'
				>
					Suivez le guide !
				</Button>
			</Trans>
		</SpaceVisitDialog>
	)
}

export const Infobox = ({ space }: { space: Space }) => {
	let comp = null

	const [activeStep] = useBookingActiveStep()

	// ✍  Renseignez les jours qui vous intéressent, nos équipes vous ferons une offre personnalisée
	if (activeStep === 'start') {
		comp = <VisitInfobox space={space} />
	} else if (activeStep === 'daySelect') {
		comp = (
			<Trans>
				🌈 Soyez prévoyant et économisez <strong>jusqu'à 30%</strong> sur votre
				réservation en anticipant votre évènement.
			</Trans>
		)
	} else if (activeStep === 'timeSelect') {
		comp =
			space.capacity <= 5 ? (
				<Trans>
					👉 Vous pourrez <strong>annuler gratuitement</strong> votre
					réservation <strong>jusqu'à 2h avant</strong> votre évènement.
				</Trans>
			) : (
				<Trans>
					👉 Vous pourrez <strong>annuler gratuitement</strong> votre
					réservation <strong>jusqu'à 3 jours avant</strong> votre évènement.
				</Trans>
			)
	}

	if (activeStep === 'multiDaysSelect') {
		comp = (
			<Trans>
				🌈 Soyez prévoyant et économisez <strong>jusqu'à 30%</strong> sur votre
				réservation en anticipant votre évènement.
			</Trans>
		)
	}

	if (!comp) return null

	return (
		<motion.div
			animate={{ opacity: 1 }}
			className='relative z-30 order-1 touch-none border-slate-200 max-md:rounded-b-none max-md:border-b md:order-2'
			exit={{ opacity: 0 }}
			initial={{ opacity: 1 }}
		>
			<Card className='p-4 text-sm'>{comp}</Card>
		</motion.div>
	)
}
